/**
 * @generated SignedSource<<a003a82ee8a72440a8f31a7865231a8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteLessonStageInput = {
  clientMutationId?: string | null | undefined;
  lessonStageId: string;
};
export type DeleteLessonStageMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteLessonStageInput;
};
export type DeleteLessonStageMutation$data = {
  readonly deleteLessonStage: {
    readonly deletedLessonStageId: string | null | undefined;
    readonly errors: any | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type DeleteLessonStageMutation = {
  response: DeleteLessonStageMutation$data;
  variables: DeleteLessonStageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedLessonStageId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteLessonStageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteLessonStagePayload",
        "kind": "LinkedField",
        "name": "deleteLessonStage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteLessonStageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteLessonStagePayload",
        "kind": "LinkedField",
        "name": "deleteLessonStage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedLessonStageId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bf34cae5a339357f44f3a7cd77103f98",
    "id": null,
    "metadata": {},
    "name": "DeleteLessonStageMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteLessonStageMutation(\n  $input: DeleteLessonStageInput!\n) {\n  deleteLessonStage(input: $input) {\n    success\n    errors\n    deletedLessonStageId\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd2ac8ab55f40521f65de87f504ff12f";

export default node;
